import React, { useCallback } from 'react';
import { Card } from 'react-bootstrap';
import { useAuth } from '../Auth/AuthProvider';
import { Details, formatDate, PageTitle, ResourceState, Seats, SsoDetails, useAdminApi, useAdminResource } from './shared';
import AnalyticsDashboard from '../Analytics/AnalyticsDashboard';

export function Overview() {
  const api = useAdminApi(); const { user } = useAuth();
  const resource = useAdminResource(useCallback(async () => {
    const [organization, subscription, employees, sso] = await Promise.all([api.organization(), api.subscription(), api.employees('ACTIVE'), api.ssoStatus()]);
    return { organization, subscription, employees, sso };
  }, [api]));
  const data = resource.data;
  return <section className="ta-page"><PageTitle title="Overview" /><ResourceState resource={resource}>
    {data && <><Seats seats={data.employees?.seats} /><div className="ta-grid">
      <Card><Card.Body><h2>Organization</h2><Details values={[
        ['Organization name', data.organization?.name], ['Tenant status', data.organization?.status],
        ['Authentication mode', data.organization?.authenticationMode], ['Subscription status', data.subscription?.status],
      ]} /></Card.Body></Card>
      <Card><Card.Body><h2>Single sign-on</h2><SsoDetails sso={data.sso} /></Card.Body></Card>
      <Card><Card.Body><h2>Your account</h2><Details values={[
        ['Display name', user.displayName], ['Email', user.email], ['Roles', user.roles.join(', ')],
        ['Account status', user.status], ['Last login', formatDate(user.lastLoginAt)],
      ]} /></Card.Body></Card>
    </div></>}
  </ResourceState><AnalyticsDashboard embedded /></section>;
}

export function Organization() {
  const api = useAdminApi(); const resource = useAdminResource(useCallback(() => api.organization(), [api]));
  const organization = resource.data;
  return <section className="ta-page"><PageTitle title="Organization" /><p>Organization information is read-only. Contact Cobygo to request changes.</p>
    <ResourceState resource={resource}>{organization ? <Card><Card.Body><Details values={[
      ['Organization name', organization.name], ['Primary domain', organization.domain],
      ['Tenant status', organization.status], ['Authentication mode', organization.authenticationMode],
    ]} /></Card.Body></Card> : <p>No organization information is available.</p>}</ResourceState>
  </section>;
}

export function Subscription() {
  const api = useAdminApi();
  const resource = useAdminResource(useCallback(async () => {
    const [subscription, employees] = await Promise.all([api.subscription(), api.employees('ACTIVE')]);
    return { subscription, seats: employees?.seats };
  }, [api]));
  const subscription = resource.data?.subscription;
  return <section className="ta-page"><PageTitle title="Subscription" /><p>Subscription and seat information is read-only. Contact Cobygo to discuss changes.</p>
    <ResourceState resource={resource}>{resource.data && <><Seats seats={resource.data.seats} />
      {subscription ? <Card><Card.Body><Details values={[
        ['Current offering', subscription.offeringCode], ['Allocated seats', subscription.allocatedSeats],
        ['Subscription status', subscription.status], ['Start date', formatDate(subscription.startsAt)],
        ['End date', formatDate(subscription.endsAt)],
      ]} /><h2>Entitlements</h2>
        {Array.isArray(subscription.entitlements) ? <>
          <p>MCP access: {subscription.entitlements.includes('MCP_ACCESS') ? 'Included' : 'Not included'}</p>
          {subscription.entitlements.length ? <ul>{subscription.entitlements.map(code => <li key={code}>{code}</li>)}</ul> : <p>No entitlements returned.</p>}
        </> : <p>Entitlement information is not provided.</p>}
      </Card.Body></Card> : <p>No active subscription was returned by the server.</p>}
    </>}</ResourceState>
  </section>;
}
